import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function UserHomeHeader({ user, onToggleSidebar, onLogout, isMobile }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Get user initials
  const getInitials = () => {
    if (!user) return '?';
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  // Generate avatar color from name
  const getAvatarColor = () => {
    if (!user) return '#6366f1';
    
    const name = `${user.firstName || ''}${user.lastName || ''}`;
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const colors = [
      '#6366f1', '#8b5cf6', '#ec4899', '#f43f5e', 
      '#f97316', '#eab308', '#22c55e', '#14b8a6', 
      '#06b6d4', '#3b82f6'
    ];
    
    return colors[Math.abs(hash) % colors.length];
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    navigate('/user-home/profile');
  };

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    onLogout();
  };

  return (
    <header className="user-home-layout__header">
      <div className="user-home-layout__header-left">
        {isMobile && (
          <button 
            className="user-home-layout__hamburger"
            onClick={onToggleSidebar}
            aria-label="Toggle menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        )}
        
        <a
          href="/"
          className="user-home-layout__logo"
          aria-label="CerebralMachines home"
        >
          <img src="/CMLogo.png" alt="CerebralMachines" />
        </a>
      </div>
      
      <div className="user-home-layout__header-right">
        <div className="user-home-layout__user-menu" ref={dropdownRef}>
          <button 
            className="user-home-layout__avatar"
            style={{ backgroundColor: getAvatarColor() }}
            onClick={toggleDropdown}
            aria-label="User menu"
          >
            {getInitials()}
          </button>
          
          {isDropdownOpen && (
            <div className="user-home-layout__dropdown">
              <div className="user-home-layout__dropdown-header">
                <div className="user-home-layout__dropdown-name">
                  {user?.firstName} {user?.lastName}
                </div>
                <div className="user-home-layout__dropdown-email">
                  {user?.email}
                </div>
              </div>
              
              <div className="user-home-layout__dropdown-divider"></div>
              
              <button 
                className="user-home-layout__dropdown-item"
                onClick={handleProfileClick}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Profile
              </button>
              
              <button 
                className="user-home-layout__dropdown-item"
                onClick={handleLogoutClick}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default UserHomeHeader;



